import { render, staticRenderFns } from "./GalasysNewAccount.vue?vue&type=template&id=2461d12a&scoped=true"
import script from "./GalasysNewAccount.vue?vue&type=script&lang=js"
export * from "./GalasysNewAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461d12a",
  null
  
)

export default component.exports